import React from 'react'
import styles from './styles.css'
import moment from 'moment'

export default function ImportantInfo(props) {
  const {vehicle} = props

  return (
    <div className={styles.container}>
      {vehicle.bannedAt ? (
        <div className={styles.containerInfo}>
          <span className={styles.badgeDanger}>
            Baneado,{' '}
            {vehicle.liftBanAt
              ? moment(vehicle.liftBanAt).format('DD/MM/YYYY HH:mm')
              : 'de forma indefinida'}
          </span>
        </div>
      ) : null}

      <div>{vehicle.phone}</div>
    </div>
  )
}
